module.exports = __webpack_public_path__ + "media/images/icons/dropup-a3cbef50b9251834d264e31ceb593c1c.svg";